import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/authSlice';
import catalogReducer from '@/features/catalog/catalogSlice';
import cartReducer from '@/features/cart/cartSlice';

/**
 * Redux Store Configuration
 * 
 * Slices:
 * - auth: User authentication and shop selection
 * - catalog: Products and categories
 * - cart: Shopping cart state and calculations
 * 
 * Note: We use Redux Toolkit for simplified Redux setup with:
 * - Immer for immutable updates
 * - Redux Thunk for async actions
 * - Redux DevTools integration
 */

export const store = configureStore({
  reducer: {
    auth: authReducer,
    catalog: catalogReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serialization checks
        ignoredActions: ['cart/addItem', 'cart/updateItem'],
        // Ignore these paths in the state
        ignoredPaths: ['cart.calculation.items'],
      },
    }),
  devTools: import.meta.env.DEV, // Enable Redux DevTools in development
});

// Infer types from store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export store as default
export default store;
